var map = {
	"./badgeImages/icon_crown.png": 4701,
	"./bankImages/CFD_PCWeb.png": 4686,
	"./bankImages/ETF_PCWeb.png": 27492,
	"./bankImages/FX_PCWeb.png": 11673,
	"./bankImages/JapanPost_PCWeb.png": 44369,
	"./bankImages/Mizuho_PCWeb.png": 82045,
	"./bankImages/Mufg_PCWeb.png": 63900,
	"./bankImages/PayPay_PCWeb.png": 47911,
	"./bankImages/Rakuten_PCWeb.png": 6635,
	"./bankImages/Smbc_PCWeb.png": 67390,
	"./bankImages/Smtb_PCWeb.png": 72949,
	"./bankImages/bankImagesHelper": 68757,
	"./bankImages/bankImagesHelper.js": 68757,
	"./builder/asset-selection.png": 70907,
	"./builder/builders_share.png": 33420,
	"./builder/done.png": 64404,
	"./builder/help_simulation.png": 48339,
	"./builder/help_simulation_ap.png": 2815,
	"./builder/icon_builder.png": 42559,
	"./builder/step1.png": 62169,
	"./builder/step10.png": 93437,
	"./builder/step2.png": 22434,
	"./builder/step3.png": 43563,
	"./builder/step6.png": 29126,
	"./builder/step7.png": 68143,
	"./builder/step8.png": 43192,
	"./builder/step9.png": 64321,
	"./builder/try_share.png": 70825,
	"./builderInfo/infoImagesHelper": 60476,
	"./builderInfo/infoImagesHelper.js": 60476,
	"./builderInfo/multiCFD/multiCfdBuySell.png": 77821,
	"./builderInfo/multiCFD/multiCfdCounter.png": 94645,
	"./builderInfo/multiCFD/multiCfdCounterFix.png": 29004,
	"./builderInfo/multiCFD/multiCfdEntry.png": 47165,
	"./builderInfo/multiCFD/multiCfdEntryOco.png": 71808,
	"./builderInfo/multiCFD/multiCfdFollow.png": 52366,
	"./builderInfo/multiCFD/multiCfdItemsCount.png": 33548,
	"./builderInfo/multiCFD/multiCfdProfitMargin.png": 89433,
	"./builderInfo/multiCFD/multiCfdQuantity.png": 35450,
	"./builderInfo/multiCFD/multiCfdRangeSpread.png": 58075,
	"./builderInfo/multiCFD/multiCfdStopLoss.png": 33124,
	"./builderInfo/multiETF/multiEtfBuySell.png": 37113,
	"./builderInfo/multiETF/multiEtfCounter.png": 58585,
	"./builderInfo/multiETF/multiEtfCounterFix.png": 6208,
	"./builderInfo/multiETF/multiEtfEntry.png": 10097,
	"./builderInfo/multiETF/multiEtfEntryOco.png": 81052,
	"./builderInfo/multiETF/multiEtfFollow.png": 3874,
	"./builderInfo/multiETF/multiEtfItemsCount.png": 87880,
	"./builderInfo/multiETF/multiEtfProfitMargin.png": 18925,
	"./builderInfo/multiETF/multiEtfQuantity.png": 91870,
	"./builderInfo/multiETF/multiEtfRangeSpread.png": 74559,
	"./builderInfo/multiETF/multiEtfStopLoss.png": 73592,
	"./builderInfo/multiFX/multiFxBuySell.png": 35639,
	"./builderInfo/multiFX/multiFxCounter.png": 67703,
	"./builderInfo/multiFX/multiFxCounterFix.png": 21270,
	"./builderInfo/multiFX/multiFxEntry.png": 88231,
	"./builderInfo/multiFX/multiFxEntryOco.png": 41882,
	"./builderInfo/multiFX/multiFxFollow.png": 83340,
	"./builderInfo/multiFX/multiFxItemsCount.png": 55690,
	"./builderInfo/multiFX/multiFxProfitMargin.png": 83567,
	"./builderInfo/multiFX/multiFxQuantity.png": 54548,
	"./builderInfo/multiFX/multiFxRangeSpread.png": 25257,
	"./builderInfo/multiFX/multiFxStopLoss.png": 21534,
	"./builderInfo/techCFD/techCfdAllSettle.png": 55599,
	"./builderInfo/techCFD/techCfdBarType.png": 51180,
	"./builderInfo/techCFD/techCfdIndicator1.png": 27643,
	"./builderInfo/techCFD/techCfdIndicator2.png": 49312,
	"./builderInfo/techCFD/techCfdItemsCount.png": 40818,
	"./builderInfo/techCFD/techCfdRangeSpread.png": 83057,
	"./builderInfo/techETF/techEtfAllSettle.png": 61391,
	"./builderInfo/techETF/techEtfBarType.png": 79628,
	"./builderInfo/techETF/techEtfIndicator1.png": 10971,
	"./builderInfo/techETF/techEtfIndicator2.png": 48992,
	"./builderInfo/techETF/techEtfItemsCount.png": 39346,
	"./builderInfo/techETF/techEtfRangeSpread.png": 64433,
	"./builderInfo/techFX/techFxAllSettle.png": 77509,
	"./builderInfo/techFX/techFxBarType.png": 15238,
	"./builderInfo/techFX/techFxIndicator1.png": 36337,
	"./builderInfo/techFX/techFxIndicator2.png": 15226,
	"./builderInfo/techFX/techFxItemsCount.png": 5072,
	"./builderInfo/techFX/techFxRangeSpread.png": 67047,
	"./buttonImages/addLabs.png": 78246,
	"./cashIcon/cashDepositView.png": 53441,
	"./cashIcon/cashDetails.png": 47950,
	"./cashIcon/cashQuickDeposit.png": 24447,
	"./cashIcon/cashTransfer.png": 32335,
	"./cashIcon/cashWithdrawal.png": 73395,
	"./chartMake/coreRange.png": 87609,
	"./chartMake/icon_chartmake_1.png": 521,
	"./chartMake/icon_chartmake_2.png": 52338,
	"./chartMake/trendingUpCircle.svg": 32431,
	"./charts/multipleEtfAutotype.gif": 92455,
	"./charts/multipleFxAutotype.gif": 84200,
	"./charts/singleAutotype.gif": 566,
	"./chevronLeft.svg": 44760,
	"./chevronRight.svg": 35764,
	"./completion.png": 89898,
	"./downArrow.svg": 38389,
	"./flags/AUD.svg": 57868,
	"./flags/CAD.svg": 81286,
	"./flags/CHF.svg": 88755,
	"./flags/CNH.svg": 2459,
	"./flags/CZK.svg": 46860,
	"./flags/EUR.svg": 71630,
	"./flags/GBP.svg": 31603,
	"./flags/HKD.svg": 51903,
	"./flags/HUF.svg": 45787,
	"./flags/JPY.svg": 10077,
	"./flags/MXN.svg": 15421,
	"./flags/NOK.svg": 80486,
	"./flags/NZD.svg": 5541,
	"./flags/PLN.svg": 58780,
	"./flags/SEK.svg": 98893,
	"./flags/SGD.svg": 59204,
	"./flags/TRY.svg": 51693,
	"./flags/USD.svg": 5546,
	"./flags/ZAR.svg": 29317,
	"./flagsCFD/DJCUSD.svg": 33920,
	"./flagsCFD/GECEUR.svg": 4254,
	"./flagsCFD/HKCHKD.svg": 26632,
	"./flagsCFD/JPCJPY.svg": 79215,
	"./flagsCFD/NACUSD.svg": 78505,
	"./flagsCFD/RTCUSD.svg": 87656,
	"./flagsCFD/SPCUSD.svg": 22235,
	"./flagsCFD/UKCGBP.svg": 52891,
	"./flagsCFD/invast-circle.svg": 43801,
	"./flagsETF/1306.svg": 50179,
	"./flagsETF/1321.svg": 32134,
	"./flagsETF/1321_gold.svg": 8295,
	"./flagsETF/1357.svg": 34305,
	"./flagsETF/1570.svg": 67746,
	"./flagsETF/ACWI.svg": 20681,
	"./flagsETF/AGQ.svg": 74538,
	"./flagsETF/ARKK.svg": 46798,
	"./flagsETF/CHPY.svg": 7657,
	"./flagsETF/China.svg": 4342,
	"./flagsETF/DJIA.svg": 57837,
	"./flagsETF/EU.svg": 23703,
	"./flagsETF/FAS.svg": 60305,
	"./flagsETF/GDX.svg": 18008,
	"./flagsETF/GDXY.svg": 76465,
	"./flagsETF/Gold.svg": 57251,
	"./flagsETF/Gold_2.svg": 72112,
	"./flagsETF/HYG.svg": 95663,
	"./flagsETF/ITA.svg": 62271,
	"./flagsETF/IWD.svg": 14351,
	"./flagsETF/IWM.svg": 37910,
	"./flagsETF/JEPQ.svg": 51055,
	"./flagsETF/JP.svg": 53059,
	"./flagsETF/LQD.svg": 56184,
	"./flagsETF/Oil.svg": 20851,
	"./flagsETF/QQQ.svg": 56452,
	"./flagsETF/QTUM.svg": 88020,
	"./flagsETF/SMH.svg": 16671,
	"./flagsETF/SOXL.svg": 2235,
	"./flagsETF/SPY.svg": 11121,
	"./flagsETF/SSO.svg": 53750,
	"./flagsETF/Silver.svg": 29190,
	"./flagsETF/TMF.svg": 24990,
	"./flagsETF/TMV.svg": 81902,
	"./flagsETF/TQQQ.svg": 89270,
	"./flagsETF/UGL.svg": 28763,
	"./flagsETF/US.svg": 41849,
	"./flagsETF/VWO.svg": 80535,
	"./flagsETF/VXX.svg": 42413,
	"./flagsETF/World.svg": 2923,
	"./flagsETF/XLE.svg": 4186,
	"./flagsETF/XLF.svg": 19273,
	"./flagsETF/XLI.svg": 66190,
	"./flagsETF/XLK.svg": 15596,
	"./flagsETF/XLP.svg": 56359,
	"./flagsETF/XLU.svg": 74,
	"./flagsETF/XLY.svg": 66750,
	"./flagsETF/invast-circle.svg": 75599,
	"./flagsETF/qqq_gold.svg": 60701,
	"./flagsETF/spy_gold.svg": 98502,
	"./flagsETF/tqqq_gold.svg": 77687,
	"./flagsETF/xlk_gold.svg": 82597,
	"./flagsETF/xly_gold.svg": 6655,
	"./fonts/M_PLUS_1p/MPLUS1p-Black.ttf": 97448,
	"./fonts/M_PLUS_1p/MPLUS1p-Bold.ttf": 99526,
	"./fonts/M_PLUS_1p/MPLUS1p-ExtraBold.ttf": 48154,
	"./fonts/M_PLUS_1p/MPLUS1p-Light.ttf": 87101,
	"./fonts/M_PLUS_1p/MPLUS1p-Medium.ttf": 94438,
	"./fonts/M_PLUS_1p/MPLUS1p-Regular.ttf": 59141,
	"./fonts/M_PLUS_1p/MPLUS1p-Thin.ttf": 45658,
	"./fonts/M_PLUS_1p/OFL.txt": 49155,
	"./fonts/Noto_Sans_JP/NotoSansJP-VariableFont_wght.ttf": 36183,
	"./fonts/Noto_Sans_JP/OFL.txt": 28608,
	"./fonts/Noto_Sans_JP/README.txt": 41037,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Black.ttf": 55517,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Bold.ttf": 37605,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-ExtraBold.ttf": 37063,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-ExtraLight.ttf": 40062,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Light.ttf": 97068,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Medium.ttf": 44969,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Regular.ttf": 19420,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-SemiBold.ttf": 24559,
	"./fonts/Noto_Sans_JP/static/NotoSansJP-Thin.ttf": 92045,
	"./labImages/bad.png": 79285,
	"./labImages/builders_lab_banner.png": 38977,
	"./labImages/builders_lab_banner_CFD.png": 75485,
	"./labImages/builders_lab_banner_ETF.png": 91431,
	"./labImages/defaultIconImages/icon_a1.png": 27267,
	"./labImages/defaultIconImages/icon_a2.png": 90408,
	"./labImages/defaultIconImages/icon_a3.png": 625,
	"./labImages/defaultIconImages/icon_a4.png": 17534,
	"./labImages/defaultIconImages/icon_a5.png": 70023,
	"./labImages/defaultIconImages/icon_f1.png": 27198,
	"./labImages/defaultIconImages/icon_f2.png": 12949,
	"./labImages/defaultIconImages/icon_f3.png": 77036,
	"./labImages/defaultIconImages/icon_f4.png": 36931,
	"./labImages/defaultIconImages/icon_f5.png": 89178,
	"./labImages/defaultIconImages/icon_h1.png": 51172,
	"./labImages/defaultIconImages/icon_h2.png": 36447,
	"./labImages/defaultIconImages/icon_h3.png": 82646,
	"./labImages/defaultIconImages/icon_h4.png": 32617,
	"./labImages/defaultIconImages/icon_h5.png": 8416,
	"./labImages/defaultIconImages/icon_r1.png": 55122,
	"./labImages/defaultIconImages/icon_r2.png": 45833,
	"./labImages/defaultIconImages/icon_r3.png": 91008,
	"./labImages/defaultIconImages/icon_r4.png": 42335,
	"./labImages/defaultIconImages/icon_r5.png": 46006,
	"./labImages/excellent.png": 30174,
	"./labImages/good.png": 33873,
	"./labImages/iconSelect.png": 68297,
	"./labImages/labImages": 51991,
	"./labImages/labImages.js": 51991,
	"./labImages/labImagesHelper": 65519,
	"./labImages/labImagesHelper.js": 65519,
	"./labImages/performanceImages/bad.png": 12292,
	"./labImages/performanceImages/excellent.png": 14667,
	"./labImages/performanceImages/good.png": 94178,
	"./labImages/performanceImages/verygood.png": 18038,
	"./labImages/stepImages/icon_step1.png": 88534,
	"./labImages/stepImages/icon_step2.png": 20301,
	"./labImages/stepImages/icon_step3.png": 57060,
	"./labImages/stepImages/icon_step4.png": 11867,
	"./labImages/verygood.png": 94037,
	"./learnTriauto/beginDeposit.png": 51518,
	"./learnTriauto/beginRunAuto.png": 75346,
	"./logic/bear_gurutore.gif": 48308,
	"./logic/bull_gurutore.gif": 98499,
	"./logic/chartmakeCover/core_ranger.gif": 97183,
	"./logic/chartmakeCover/core_ranger_bear.gif": 82488,
	"./logic/chartmakeCover/core_ranger_bull.gif": 58741,
	"./logic/chartmakeCover/half.gif": 64019,
	"./logic/chartmakeCover/hedger.gif": 75783,
	"./logic/chartmakeCover/protector.gif": 89002,
	"./logic/chartmakeCover/swapper.gif": 34598,
	"./logic/chartmake_hedger.gif": 97800,
	"./logic/core_ranger.gif": 19541,
	"./logic/core_ranger_bear.gif": 12638,
	"./logic/core_ranger_bull.gif": 90255,
	"./logic/counter.gif": 76990,
	"./logic/follow.gif": 91193,
	"./logic/half.gif": 61721,
	"./logic/hedger.gif": 41305,
	"./logic/labo.png": 40529,
	"./logic/logic7.gif": 75655,
	"./logic/logicIMagesHelper": 28909,
	"./logic/logicIMagesHelper.js": 28909,
	"./logic/protector.gif": 79788,
	"./logic/rising.gif": 868,
	"./logic/short.gif": 86344,
	"./logic/strategist.png": 56347,
	"./logic/swapper.gif": 30744,
	"./logic/three_cards.gif": 84034,
	"./login/logo.svg": 34093,
	"./login/passkey.svg": 81304,
	"./logoAppStore.svg": 3767,
	"./logoGooglePlay.svg": 21592,
	"./logoTriautoCFD.png": 30278,
	"./logoTriautoETF.png": 18616,
	"./logoTriautoFX.png": 24349,
	"./logos/applogo_splash_triauto.svg": 43164,
	"./logos/header_triauto_logo.png": 51865,
	"./logos/tool_triauto_logo.svg": 87110,
	"./logos/triauto.ico": 16568,
	"./message/mail.png": 32641,
	"./message/orderCompleted.png": 60219,
	"./newsMode.svg": 29462,
	"./omakasePlan/budget-icon.png": 95616,
	"./omakasePlan/description-icon.png": 64783,
	"./omakasePlan/policy-balance-icon.png": 20978,
	"./omakasePlan/policy-icon.png": 16943,
	"./omakasePlan/policy-return-icon.png": 52742,
	"./omakasePlan/term-icon.png": 26967,
	"./omakasePlanImages/omakasePlanBannerImage.png": 12504,
	"./select/recommended_strategy_diagnosis.png": 63464,
	"./selectionImages/AUDCAD.png": 62801,
	"./selectionImages/AUDJPY.png": 16034,
	"./selectionImages/AUDNZD.png": 23965,
	"./selectionImages/AUDNZD_EURGBP.svg": 8607,
	"./selectionImages/AUDUSD.png": 43845,
	"./selectionImages/CADJPY.png": 64756,
	"./selectionImages/CHFHUF.png": 55389,
	"./selectionImages/CHFJPY.png": 3311,
	"./selectionImages/CHFJPY_AUDNZD_USDJPY.svg": 58854,
	"./selectionImages/CHFJPY_CADJPY_AUDNZD.svg": 26836,
	"./selectionImages/CHFJPY_CADJPY_EURGBP.svg": 90843,
	"./selectionImages/CHFJPY_EURGBP.svg": 61741,
	"./selectionImages/CHFJPY_EURGBP_AUDNZD.svg": 85462,
	"./selectionImages/CHFJPY_EURGBP_USDJPY.svg": 43795,
	"./selectionImages/CHFMXN.png": 48127,
	"./selectionImages/CHFTRY.png": 38971,
	"./selectionImages/CHFZAR.png": 9595,
	"./selectionImages/CNHJPY.png": 48759,
	"./selectionImages/CZKJPY.png": 46542,
	"./selectionImages/EURAUD.png": 65665,
	"./selectionImages/EURCHF.png": 64042,
	"./selectionImages/EURGBP.png": 55114,
	"./selectionImages/EURJPY.png": 6332,
	"./selectionImages/EURPLN.png": 36365,
	"./selectionImages/EURUSD.png": 53431,
	"./selectionImages/GBPCHF.png": 87705,
	"./selectionImages/GBPJPY.png": 30975,
	"./selectionImages/GBPUSD.png": 6472,
	"./selectionImages/HUFJPY.png": 94851,
	"./selectionImages/MXNJPY.png": 97897,
	"./selectionImages/NOKJPY.png": 95396,
	"./selectionImages/NOKSEK.png": 14296,
	"./selectionImages/NOKZAR.png": 88408,
	"./selectionImages/NZDCAD.png": 1507,
	"./selectionImages/NZDJPY.png": 59444,
	"./selectionImages/NZDUSD.png": 12047,
	"./selectionImages/PLNJPY.png": 90358,
	"./selectionImages/TRYJPY.png": 76721,
	"./selectionImages/USDCAD.png": 59015,
	"./selectionImages/USDCHF.png": 75814,
	"./selectionImages/USDJPY.png": 64880,
	"./selectionImages/USDJPY_AUDNZD.svg": 31091,
	"./selectionImages/USDJPY_EURGBP.svg": 22336,
	"./selectionImages/USDJPY_EURGBP_AUDNZD.svg": 21853,
	"./selectionImages/USDSGD.png": 16093,
	"./selectionImages/ZARJPY.png": 72533,
	"./selectionImages/invast.png": 12824,
	"./selectionImages/multi.svg": 63708,
	"./selectionImages/nintei.png": 99512,
	"./selectionImages/omakase.svg": 43310,
	"./selectionImages/strategist.svg": 7923,
	"./settings.svg": 70421,
	"./technicalBuilder/icon_technicalbuilder.png": 1335,
	"./tutorial/cashThumbnail.png": 13052,
	"./tutorial/recomend.png": 55834,
	"./tutorial/step1pc.png": 20247,
	"./tutorial/step2pc.png": 81092,
	"./tutorial/step3pc.png": 10261,
	"./tutorial/step4pc.png": 16450,
	"./tutorial/step5pc.png": 15539,
	"./tutorial/step6pc.png": 70176,
	"./tutorial/step7pc.png": 94801,
	"./tutorial/step8pc.png": 77358,
	"./upArrow.svg": 91420,
	"./youtube.svg": 18549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;